module.exports = __webpack_public_path__ + "f54e58e078aa2c8e998a3a3ef873f117.png";


//////////////////
// WEBPACK FOOTER
// ./client/assets/img/cup.png
// module id = 89
// module chunks = 0